import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { QualiHeading } from '../../components';

class NavigationHeader extends Component {
  constructor(props) {
    super(props);
    this.brandId = props.id;
    this.state = {changeError: false}
  }

  handleNav = (event) => {
    if (this.state.changeError === true) {
      this.setState({ renderChangeError: true, portal: true });
    } else {
      if (event.target.name === 'previous') {
        this.props.history.push(`/brandCauses/${this.brandId}`);
      } else if(event.target.name === 'next') {
        this.props.history.push(`/brandSummary/${this.brandId}`);
      } else if(event.target.name === 'landing') {
        this.props.history.push(`/brandLanding/${this.brandId}`);
      }
    }
  }

  render = () => {
    return (
      <Fragment>
        <QualiHeading id={this.brandId} brand={this.props.brand}/>
        <div className='forms-header'><button onClick={(evt) => this.handleNav(evt)} name='landing'>Back to Summary</button></div>
        <div className='forms-header'>
          <span className='form-navigation'>
            <div><button onClick={(evt) => this.handleNav(evt)} name='previous' className='previous'>Previous</button></div>
            <div><h3>Brand Sentences</h3></div>
            <div><button onClick={(evt) => this.handleNav(evt)} name='next' className='next'>Next</button></div>
          </span>
        </div> 
      </Fragment>
    )
  }
}  

NavigationHeader.propTypes = {
  id: PropTypes.string.isRequired,
  brand: PropTypes.object.isRequired,
};

export default withRouter(NavigationHeader);



// WEBPACK FOOTER //
// ./src/components/Sentences/NavigationHeader.js